import { SxProps, Theme } from '@mui/material';

export const dpOrderConfCard: SxProps<Theme> = {
	border: '1px solid #EDEDED',
	boxShadow: 'none',
	borderRadius: '4px',
	marginTop: '9px',
};

export const dpOrderConfTitle: SxProps<Theme> = {
	fontSize: 'var(--font-size-md)',
	fontWeight: '900',
	textTransform: 'uppercase',
	letterSpacing: '0',
	color: '#2C2C2C',
};

export const dpOrderConfDesc: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	fontWeight: 'normal',
	letterSpacing: '0',
	color: '#2C2C2C',
	mt: '5px',
};

export const dpOrderConfContent: SxProps<Theme> = {
	my: '20px',
	mx: '25px',
};

export const dpOrderConfAction: SxProps<Theme> = {
	mt: '15px',
};

export const dpOrderConfButton: SxProps<Theme> = {
	width: '183px',
	borderRadius: '22px',
	paddingTop: '9px',
	paddingBottom: '9px',
};
